import { render, staticRenderFns } from "./DateInspectionEdit.vue?vue&type=template&id=fe04a7bc&scoped=true&"
import script from "./DateInspectionEdit.vue?vue&type=script&lang=ts&"
export * from "./DateInspectionEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DateInspectionEdit.vue?vue&type=style&index=0&id=fe04a7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe04a7bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
